import {defaultSelectedPlaneacion, filtro} from './state';

export function setListasPlaneacion(state, planeacionesAuditorias) {
    state.planeacionesAuditorias = planeacionesAuditorias;
}

export function setListasPlaneacionHallazgos(state, planeacionesAuditoriasHallazgos) {
    state.planeacionesAuditoriasHallazgos = planeacionesAuditoriasHallazgos;
}

export function setListaRegistros(state, registros) {
    state.listaRegistros = registros;
}

export function setPlaneacion(state, planeacionesAuditorias) {
    state.selectedPlaneacion = planeacionesAuditorias;
}

export function setTipoListaChequeo(state, tipoListaChequeo) {
    state.tipoListaChequeo = tipoListaChequeo;
}

export function limpiarFiltro(state) {
    state.filtro = filtro();
    state.planeacionesAuditorias = {};
}

export function setPlaneacionId(state, id) {
    state.selectedPlaneacionAuditoria.id_planeacion = id;
}

export function establecerEmpresas(state, empresas) {
    state.empresas = empresas;
}

export function cargarEvidencia(state, evidencia) {
    state.empresas = evidencia.data;
}

export function setAccion(state, action) {
    state.accion = action;
}

/**
 *
 * @param {*} state
 */
export function accionError(state) {
    state.error = true;
}

export function setFiltroEmpresa(state, buscar) {
    state.filtro.id_empresa = buscar;
}

export function setfiltroRegistro(state, buscar) {
    state.filtroRegistro.id_empresa = state.selectedPlaneacion.id_empresa;
    state.filtroRegistro.id_planeacion = state.selectedPlaneacion.id;
    state.filtroRegistro.id_item = buscar.id;
}

export function setPage(state, page) {
    state.filtro.page = page;
}

export function setPermisosAdmin(state, permiso) {
    state.esAdmin = permiso;
}

export function setPermisosEmpresa(state, permiso) {
    if (!state.esAdmin) {
        state.esEmpresa = permiso;
    }
}

/**
 * Establecer las planificaciones.
 * 
 * @param {*} state 
 * @param {*} findings 
 * 
 * @return array auditPannings
 * @author Fernando Claros
 */
export function setAuditPlanning(state, findings = []) {
    const preparedData = []; 

    try {

        findings.map(finding => { // categorias
            finding.items.map(item => { // sub-items
                preparedData.push({
                    id: item.id_planeacion_auditoria,
                    id_planeacion: state.selectedPlaneacion.id,
                    id_empresa: state.selectedPlaneacion.id_empresa,
                    id_lista_chequeo: state.selectedPlaneacion.id_tipo_lista_chequeo,
                    id_tipo_seguimiento: item.id_tipo_seguimiento,
                    id_item: item.id,
                    evidencia: item.evidencia ? item.evidencia : '',
                });
            })
        })

    } catch (e) { }

    state.selectedPlaneacion.planeacion_auditoria = preparedData;
}

export function establecerPlaneacionAuditoria(state) {
    state.selectedPlaneacion.planeacion_auditoria = state.hallazgoArr;
}

export function setParametroSeguimiento(state, id) {
    state.lista.id_tipo_lista_chequeo = id;
}

/**
 *
 * @param {*} state
 * @param {*} tipoSeguimientos
 */
export function setMostrarTipoSeguimiento(state, tipoSeguimientos) {

    tipoSeguimientos.map(i => {
        i.items = i.items_lista_chequeos.length > 0 ? i.items_lista_chequeos : i.items;
    });

    if (state.selectedPlaneacion.planeacion) {
        tipoSeguimientos.map(i => {
            i.items.map(item => {
                state.selectedPlaneacion.planeacion.map(plan => {
                    if (item.id === plan.id_item) {
                        item.registro = plan.registro || [];
                        item.id_planeacion_auditoria = plan.id;
                        item.evidencia = plan.evidencia;
                    }
                });
            });
        });
    }

    state.listaTipoSeguimientos = tipoSeguimientos;
}

/**
 * Mutación para limpiar las listas del formulario de preinspecciones
 *
 * @export
 * @param {*} state
 */
export function resetlistaTipoSeguimientos(state) {
    state.listaTipoSeguimientos = [];
}

export function resetSelectedPlaneacionAuditoria(state) {
    Object.assign(state.selectedPlaneacion, defaultSelectedPlaneacion());
}

export function establecerCargandoDatosSelect(state, cargando_datos_select) {
    state.cargando_datos_select = cargando_datos_select;
}

/**
 * Establecer empresas
 */
export function establecerEmpresasFiltro(state, empresas) {
    state.empresas_filtro = empresas;
}

/**
 * Establecer id empresa filtro
 */
export function establecerIdEmpresaFiltro(state, id_empresa) {
    state.filtro.id_empresa = id_empresa;
}

/**
 * Establecer id empresa planeacion
 */
export function establecerIdEmpresaSelectedPlaneacion(state, id_empresa) {
    state.selectedPlaneacion.id_empresa = id_empresa;
}

/**
 * Establecer modal ver
 */
export function establecerModal(state, ver) {
    state.modal.ver = ver;
}




